import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { RegistrationService } from '@app/registration/registration.service';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { map, startWith, take, takeUntil } from 'rxjs';

import { HttpService } from '@core/services/http.service';
import { forkJoin } from 'rxjs';
import { CommonService } from '@app/shared/services/common.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading, toastMessage } from '@app/shared/constants/modal.model';
import { STATE_LIST } from '@app/shared/constants/state.constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UpdateEmailComponent } from '../update-email/update-email.component';
import { AlertService } from '@app/@core/services/alert.service';
import { AuthService } from '@pics-core/dynamic';
import { ComplaintFormService } from '../complaint-form.service';
import { LoaderService } from '@app/@core/services/loader.service';
import { patternMatch } from '@app/shared/constants/validators.model';
import { DateMaskDirective } from '@app/shared/directives/dateMask.directive';



@Component({
  selector: 'app-raise-a-complaint',
  templateUrl: './raise-a-complaint.component.html',
  styleUrls: ['./raise-a-complaint.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DataGridComponent,
    DxDataGridModule,
    DxPopupModule,
    DxTemplateModule,
    DxButtonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    EditorModule,
    InputMaskModule,
    InputTextModule,
    RadioButtonModule,
    DropdownModule,
    DialogModule,
    DateMaskDirective
  ]
})

export class RaiseAComplaintComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  originalRowValues: { [key: string]: any } = {};
  showEditWitnessModal: boolean = false;
  @ViewChild('editWitnessModal', { static: false }) editWitnessModal!: TemplateRef<any>;
  @ViewChild('fileInputRef') fileInputRef!: ElementRef<HTMLInputElement>;
  private dtEffEndDateDestroy$ = new Subject<void>();
  effEndDateToolTip: any;
  toastMessage: any = {};
  witnessesForm: FormGroup;
  editWitnessesForm: FormGroup;
  complaintForm: FormGroup;
  details: boolean = true;
  Witnesses: boolean = true;
  Complainants: boolean = true;
  acknowledgement: boolean = true;
  stateList = STATE_LIST;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;
  @ViewChild('employeeGrid') employeeGrid?: DataGridComponent;
  // dataGridConfigEmployee: DataGridVO = DataGridVO.create({});
  // dataGridConfigApplication: DataGridVO = DataGridVO.create({});
  // dataGridConfigSecurity: DataGridVO = DataGridVO.create({});
  // examHeaders: any[] = [];
  // educationRows: any[] = [];
  text: string | undefined;
  editWitnessIndex: number | undefined;
  examExists = false;
  modalExamData: any = {};
  modalExamNameExists = false;
  selectedExam: any = null;
  // ExamRequirements: boolean = true;
  // examRows: ExamRequirement[] = [];
  witnessesDataGridConfig: DataGridVO = DataGridVO.create({});
  supportingWitnessesDataGrid: DataGridVO = DataGridVO.create({});
  customModal: NgbModalRef;
  createdDateFilterOptions: string[] = [];
  createdDateFilterDates: { [year: string]: string[] } = {};
  applicationData: any;
  applicationData2: any;
  applicationStatus: any[] = [];
  filteredwitnessesData: any[] = [];
  filteredsupportingWitnessesData: any[] = [];
  applicationtypes: any[] = [];
  uploadedFiles: any[] = [];
  // suffixData: any[] = [];
  witnessesHeaders: any[] = [];
  supportingWitnessesHeaders: any[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  visibleSupportingColumns: { [key: string]: boolean } = {};
  allColumns: any[] = [];
  allSupportingColumns: any[] = [];
  showColumnChooser = false;
  showSupportingColumnChooser = false;
  showDownloadDialog = false;
  rowDownloadDialogIndex: number | null = null;
  readonly disableAppIdColumn = 'application_id';
  // showAppIdFilterDialog = false;
  appIdFilterOptions: string[] = [];
  appIdFilterSelected: string[] = [];
  // appIdFilterAllSelected = false;
  appTypeFilterOptions: string[] = [];
  appTypeFilterSelected: string[] = [];
  appTypeFilterAllSelected = false;
  // showAppStatusFilterDialog = false;
  // appStatusFilterOptions: string[] = [];
  // appStatusFilterSelected: string[] = [];
  // appStatusFilterAllSelected = false;
  // showAppTypeFilterDialog = false;
  selectedApplicationId: string | null = null;
  showDeleteModal: boolean = false;
  witnessDeleteIndex: number | null = null;
  showDraftModal: boolean = false;
  draftApplication: any = null;
  // selectedDraftApplicationType: string = '';

  // searchFilters = {
  //   application_id: '',
  //   application_type: '',
  //   created_date: '',
  //   submitted_date: '',
  //   application_status: ''
  // };
  uploadError: string | null = null;
  lookupMessages: any;
  lookupToast: any;
  lookupGeneric: any;
  lookupPlaceholder: any;
  searchStates = {
    application_id: false,
    application_type: false,
    created_date: false,
    submitted_date: false,
    application_status: false
  };
  previousUrl: any;
  supportingDocDeleteIndex: number | null = null;
  isSupportingDelete: boolean = false;

  showCreatedDateFilterDialog = false;
  // createdDateFilterSelected: string[] = [];
  // createdDateFilterAllSelected = false;
  // expandedCreatedYears: { [year: string]: boolean } = {};
  showSubmittedDateFilterDialog = false;
  // submittedDateFilterOptions: string[] = [];
  // submittedDateFilterDates: { [year: string]: string[] } = {};
  // submittedDateFilterSelected: string[] = [];
  // submittedDateFilterAllSelected = false;
  // expandedSubmittedYears: { [year: string]: boolean } = {};
  // createdDate: string = '';
  // submittedDate: string = '';
  isLoading: boolean = false;
  showToast: boolean = false;
  toastType: string = '';
  toastMessageText: string = '';
  toastTitle: string = '';
  toastTimer: any;
  saveText: string = 'Update';
  errorMessages: any[] = [];
  errorMessage: any = {};
  genericMessage: any = {};
  original$!: Observable<any>;
  isChanged$!: Observable<boolean>;
  phoneExists: boolean = false;
  phoneError: boolean = false;
  isPhoneFocused: boolean = false;
  toastMessages: any[] = [];
  genericMessages: any[] = [];
  placeholderMessages: any[] = [];
  placeholderMessage: any = {};
  oneFileIsRequired: boolean;
  oneFileIsRequiredError: string;
  categoryError: string;
  docTypeError: string;
  filteredDocumentTypes: any[] = [];
  categories: any[] = [];
  @Input()
  id: number | null = null;
  uploadData: any = {
    file: null,
    category: '',
    docType: ''
  };
  selectedFile: File | null = null;
  saveEnable: boolean = true;
  @ViewChild('dateTextInput') dateTextInput?: ElementRef<HTMLInputElement>;
  @ViewChild('startHiddenDateInput') startHiddenDateInput?: ElementRef<HTMLInputElement>;
  todayString:string;
  constructor(
    private readonly fb: FormBuilder,
    private ngbService: NgbModal,
    private readonly registrationService: RegistrationService,
    private httpService: HttpService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private elRef: ElementRef,
    private commonService: CommonService,
    private modalService: NgbModal,
    private readonly alertService: AlertService,
    private authServices: AuthService,
    private complaintFormService: ComplaintFormService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
  ) {
    this.selectedFile = null;
    this.applicationtypes = [];
    this.uploadedFiles = [];
    this.applicationData2 = [];
    this.applicationtypes = [];
    this.applicationStatus = [];
    this.filteredwitnessesData = [];
    this.filteredsupportingWitnessesData = [];
    this.appIdFilterOptions = [];
    this.appIdFilterSelected = [];
    this.appTypeFilterOptions = [];
    this.appTypeFilterSelected = [];
  }


  ngOnInit(): void {
    this.complaintForm = this.fb.group({
      dateOfComplaint: ['', [Validators.required,Validators.pattern(patternMatch.date)]],
      educatorsFirstName: ['',
        [Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]],
      complaintTextData: ['', [Validators.required]],
      complainantFirstName: ['',
        [Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]],
      complainantLastName: ['',
        [Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]],
      complainantEmail: ['', [Validators.required]],
      complainantPhoneNumber: ['',
        [Validators.required,
        Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
        Validators.maxLength(17)]],
      complainantStreetAddress: ['', [Validators.required,
      Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
      Validators.minLength(3),
      Validators.maxLength(60)]],
      complainantCity: ['',
        [
          Validators.pattern("^[A-Za-z\\s'-]{2,60}$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
      complainantState: [null, Validators.required],
      complainantZip: ['',
        [Validators.required,
        Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)]],
      conditions: [false, Validators.requiredTrue]
    });
    this.witnessesForm = this.fb.group({
      witnessesName: ['', [Validators.required,
      Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
      Validators.minLength(2),
      Validators.maxLength(30)
      ]],
      witnessesEmail: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/)]],
      witnessesPhone: ['',
        [
          Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
          Validators.maxLength(17)
        ]
      ],
      witnessesAddress: ['',
        [
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)
        ]
      ],
      witnessesCity: ['', [Validators.pattern("^[A-Za-z\\s'-]{2,60}$"), Validators.minLength(2), Validators.maxLength(60)]],
      witnessesState: [null],
      witnessesZip: ['', [
        Validators.pattern("^\\d{5}(|-\\d{4})$"),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)
      ]],
      witnessesTextData: ['']
    });
    this.complaintForm.get('complaintTextData')?.setValue('');
    this.editWitnessesForm = this.fb.group({
      witnesseName: ['',
        [Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)]
      ],
      witnessesEmail: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/)]],
      witnessesPhone: ['',
        [
          Validators.pattern('^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}-\\d{4}$'),
          Validators.maxLength(17)]
      ],
      witnessesAddress: ['',
        [
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)]
      ],
      witnessesCity: ['', [Validators.pattern("^[A-Za-z\\s'-]{2,60}$"), Validators.minLength(2), Validators.maxLength(60)]],
      witnessesState: [''],
      witnesseZip: ['', [
        Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
        Validators.minLength(5),
        Validators.maxLength(10)
      ]],
    }, { validators: this.cityStateRequiredIfZipValid });
    this.loadDropdownDataMessages();
    this.loadDashboardHeaders();
    this.loadDropdownData();
    setTimeout(() => {
      this.complaintForm.get('complaintTextData')?.setValue('');
    }, 1000);
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };

    // In ngOnInit or after form initialization, subscribe to valueChanges for validation
    // this.witnessesForm.get('witnessesEmail')?.valueChanges.subscribe(() => {
    //   this.validateWitnessEmail();
    // });
    this.witnessesForm.get('witnessesPhone')?.valueChanges.subscribe(() => {
      this.validateWitnessPhone();
    });
    this.witnessesForm.get('witnessesAddress')?.valueChanges.subscribe(() => {
      this.validateWitnessStreet();
    });
    this.witnessesForm.get('witnessesCity')?.valueChanges.subscribe(() => {
      this.validateWitnessCity();
    });
    this.witnessesForm.get('witnessesZip')?.valueChanges.subscribe(() => {
      this.formatWitnessZipCode({ target: { value: this.witnessesForm.get('witnessesZip')?.value || '' } });
    });
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    this.todayString = `${yyyy}-${mm}-${dd}`;
    this.complaintForm.get('dateOfComplaint')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value: string) => {
        let error: string | null = null;
        if (value === '' || value == null) {
          this.clearDateInput();
          return;
        }
        if (new Date(value) > new Date()) {
          error = 'futureDate';
          this.complaintForm.get('dateOfComplaint')?.setErrors({ [error]: true });
        }
      },
    });
  }

  clearDateInput(){
    // clear visible text input
    if (this.dateTextInput?.nativeElement) {
      this.dateTextInput.nativeElement.value = '';
    }
    if(this.startHiddenDateInput?.nativeElement){
      this.startHiddenDateInput.nativeElement.value = '';
    }
  }
  onStartDateChange(event: any,dateTextInput: HTMLInputElement) {
    const dateValue = event.target.value;
    if (dateValue) {
      const d = new Date(dateValue);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yyyy = d.getFullYear();
      const formatted = `${mm}/${dd}/${yyyy}`;
      this.complaintForm.get('dateOfComplaint')?.setValue(formatted);
      return;
    }
  }

  onSubmit(): void {
    const form = this.complaintForm.getRawValue();
    console.log('Form Data:', form);
    const stripHtml = (html: string): string => {
      if (!html) return '';
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    };

    // Encrypt helper
    const encrypt = (val: string) => val ? this.commonService.encrypt(val) : '';

    const payload = {
      strComplaintFirstName: encrypt(this.complaintForm.get('complainantFirstName')?.value),
      strComplaintLastName: encrypt(this.complaintForm.get('complainantLastName')?.value),
      strComplaintEmailAddress: encrypt(this.complaintForm.get('complainantEmail')?.value),
      strComplaintMobileNumber: encrypt(this.complaintForm.get('complainantPhoneNumber')?.value),
      strComplaintStreetAddress: encrypt(this.complaintForm.get('complainantStreetAddress')?.value),
      strCdCity: encrypt(this.complaintForm.get('complainantCity')?.value),
      strCdState: encrypt(this.complaintForm.get('complainantState')?.value),
      strZipcode: encrypt(this.complaintForm.get('complainantZip')?.value),
      strEducatorName: encrypt(this.complaintForm.get('educatorsFirstName')?.value),
      intCreatedBy: 101,
      dtCreatedDate: new Date().toISOString(),
      intUpdatedBy: 101,
      dtUpdatedDate: new Date().toISOString(),
      dtDateOfIncident: encrypt(this.complaintForm.get('dateOfComplaint')?.value),
      strDescription: encrypt(stripHtml(this.complaintForm.get('complaintTextData')?.value)),
      strOldId: 'abc123',
      strComplaintSource:'External',
      witnesses: this.filteredwitnessesData.map(w => {
        const descStripped = stripHtml(this.getWitnessDescription(w));
        return {
          strWitnessName: encrypt(w.strWitnessName || w.witnessesName),
          strWitnessEmailAddress: encrypt(w.strWitnessEmailAddress || w.witnessesEmail),
          strWitnessMobileNumber: encrypt(w.strWitnessPhoneNumber || w.witnessesPhone),
          strWitnessStreetAddress: encrypt(w.strStreetAddress || w.witnessesAddress),
          strCdCity: encrypt(w.strCity || w.witnessesCity),
          strCdState: encrypt(w.strState || w.witnessesState),
          strZipcode: encrypt(w.strZip || w.witnessesZip),
          strWitnessDescription: encrypt(descStripped),
          isWitnessActive: w.isWitnessActive !== undefined ? w.isWitnessActive : true,
          strWitnessCreatedBy: w.strWitnessCreatedBy,
          witnessOldId: w.witnessOldId || ''
        }
      }),
      documentUpload: this.filteredsupportingWitnessesData.map(doc => {
        return {
          strFileName: encrypt(doc.strFileName),
          strFileHash: doc.strFileHash,
          strDocumentType: doc.strDocumentType,
          strStatus: doc.strStatus,
          strCdDocumentCategory: doc.strCdDocumentCategory,
        }
      }),
      isEmailVerified: window.sessionStorage.getItem('isEmailVerified') === 'true',
      attachments: this.uploadedFiles,
    };
    console.log(payload)
    this.complaintFormService.verifySubmit(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if(response.data?.success){
          console.log('Submit success', response);
          this.alertService.success(this.toastMessage['T0049']);
          this.complaintForm.reset();
          this.witnessesForm.reset();
          this.editWitnessesForm.reset();
          this.clearDateInput();
          this.filteredwitnessesData = [];
          this.filteredsupportingWitnessesData = [];
          this.witnessesDataGridConfig = DataGridVO.create({
            customHeaders: this.witnessesHeaders,
            visibleColumns: this.visibleColumns,
            data: this.filteredwitnessesData
          });
          this.supportingWitnessesDataGrid = DataGridVO.create({
            customHeaders: this.supportingWitnessesHeaders,
            visibleColumns: this.visibleSupportingColumns,
            data: this.filteredsupportingWitnessesData
          });
        }else{
          this.alertService.error('Error submitting complaint. Please try again later.');
        }
      },
      error: (error) => {
        console.error('Error submitting complaint', error);
      }
    });
    console.log(this.complaintForm.getRawValue());
  }
  getWitnessDescription(witness: any): string {
    return witness.strWitnessDescription || witness.strWitnessTextData || '';
  }

  addData() {
    const formValue = this.witnessesForm.getRawValue();
    const newWitness = {
      strWitnessName: formValue.witnessesName,
      strWitnessEmailAddress: formValue.witnessesEmail,
      strWitnessPhoneNumber: formValue.witnessesPhone,
      strStreetAddress: formValue.witnessesAddress,
      strCity: formValue.witnessesCity,
      strState: formValue.witnessesState,
      strZip: formValue.witnessesZip,
      strWitnessTextData: formValue.witnessesTextData
    };
    this.filteredwitnessesData = [...this.filteredwitnessesData, newWitness];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.alertService.success(this.toastMessage['T0005']);
    this.witnessesForm.reset();
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
  }

  resetData() {
    this.witnessesForm.reset();
  }

  onColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleColumns[columnField] = isVisible;
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
  }
  onSupportingColumnVisibilityChange(columnField: string, isVisible: boolean) {
    this.visibleSupportingColumns[columnField] = isVisible;
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: this.supportingWitnessesHeaders,
      visibleColumns: this.visibleSupportingColumns,
      data: this.filteredsupportingWitnessesData
    });
  }

  onEditExamReset(row: any) {
    this.examExists = false;
    this.modalExamNameExists = false;
    this.selectedExam = { ...row };
    this.editWitnessesForm.patchValue({
      witnesseName: row.strWitnessName,
      witnessesEmail: row.strWitnessEmailAddress,
      witnessesPhone: row.strWitnessPhoneNumber,
      witnessesAddress: row.strStreetAddress,
      witnessesCity: row.strCity,
      witnessesState: row.strState,
      witnesseZip: row.strZip,
      witnessesTextData: row.strWitnessTextData
    });
  }

  openEditWitnessModal(row: any, index: number) {
    console.log('openEditWitnessModal called with index:', index, 'row:', row);
    this.selectedExam = { ...row };
    this.editWitnessIndex = index;
    // Find the matching state from stateList (case-insensitive)
    let matchedState = '';
    if (row.strState) {
      const found = this.stateList.find(
        (state: string) => state.toLowerCase() === row.strState.toLowerCase()
      );
      matchedState = found || '';
    }
    this.editWitnessesForm.patchValue({
      witnesseName: row.strWitnessName,
      witnessesEmail: row.strWitnessEmailAddress,
      witnessesPhone: row.strWitnessPhoneNumber,
      witnessesAddress: row.strStreetAddress,
      witnessesCity: row.strCity,
      witnessesState: matchedState || null,
      witnesseZip: row.strZip,
      witnessesTextData: row.strWitnessTextData
    });
    this.editWitnessesForm.markAsPristine();

    this.original$ = of(this.editWitnessesForm.getRawValue());

    this.isChanged$ = combineLatest([
      this.editWitnessesForm.valueChanges.pipe(startWith(this.editWitnessesForm.value)),
      this.original$
    ]).pipe(
      map(([current, original]) => JSON.stringify(current) !== JSON.stringify(original))
    );
    this.effEndDateToolTip = row.dtEffEndDate ? toastMessage.G0037 : toastMessage.G0036;
    this.showEditWitnessModal = true;
    // Reset the destroy$ subject so subscription can be re-established
    this.dtEffEndDateDestroy$ = new Subject<void>();
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'xl',
      windowClass: 'custom-edit-record-modal'
    };
    this.customModal = this.ngbService.open(this.editWitnessModal, options);
    this.dtEffEndDateDestroy$ = new Subject<void>();
  }

  closeModal() {
    this.dtEffEndDateDestroy$.next();
    this.selectedExam = null;
    this.editWitnessesForm.reset();
    this.editWitnessesForm.markAsPristine();
    this.editWitnessesForm.markAsUntouched();
    this.showEditWitnessModal = false;
    this.customModal.close();
    this.customModal = null;
  }

  // app dashboard
  loadDashboardHeaders() {
    this.commonService
      .getComplaintTabs()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          console.log('Loaded column metadata:', headers);
          this.witnessesHeaders = headers.witnessHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.supportingWitnessesHeaders = headers.supportingHeaders.map(header => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          console.log('Supporting Docs Headers:', this.supportingWitnessesHeaders);
          this.visibleColumns = {};
          this.visibleSupportingColumns = {};
          this.witnessesHeaders.forEach(header => {
            this.visibleColumns[header.dataField] = true;
          });
          this.supportingWitnessesHeaders.forEach(header => {
            this.visibleSupportingColumns[header.dataField] = true;
          });
          this.allColumns = this.witnessesHeaders;
          this.allSupportingColumns = this.supportingWitnessesHeaders;
          this.isLoading = true;
          this.checkDeviceAndRedirect();
        },
        error: (error: any) => {
          console.error('Error loading column metadata:', error);
        }
      });
  }


  private async loadDropdownDataMessages() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        this.placeholderMessages = item[3].data;
        // Process generic messages to make them easily accessible by key
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        this.placeholderMessage = {};
        this.placeholderMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
        this.cd.detectChanges();

      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }

  private async loadDropdownData() {
    this.applicationData = [];
    this.applicationData2 = [];
    this.filteredwitnessesData = this.applicationData;
    this.filteredsupportingWitnessesData = this.applicationData2;
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: this.supportingWitnessesHeaders,
      visibleColumns: this.visibleSupportingColumns,
      data: this.filteredsupportingWitnessesData
    });
    this.appIdFilterOptions = Array.from(new Set(this.applicationData.map(app => app.application_id)));
    this.appTypeFilterOptions = Array.from(
      new Set(this.applicationData.map(app => this.getApplicationTypeDisplayValue(app.application_type)))
    );
  }

  onDropFile(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const fileList = event.dataTransfer.files;
      const syntheticEvent = {
        target: {
          files: fileList
        }
      } as any;
      this.handleFileUpload(syntheticEvent);
    }
  }
  getApplicationTypeDisplayValue(key: string): string {
    if (!this.applicationtypes || !key) {
      return key || '';
    }

    const appType = this.applicationtypes.find(type => type.key === key);
    return appType ? appType.value : key;
  }

  closeColumnChooser() {
    this.showColumnChooser = false;
    this.showSupportingColumnChooser = false;
  }

  toggleDownloadDialog() {
    this.showDownloadDialog = !this.showDownloadDialog;
  }

  closeDownloadDialog() {
    this.showDownloadDialog = false;
  }

  openRowDownloadDialog(index: number) {
    if (this.rowDownloadDialogIndex === index) {
      this.rowDownloadDialogIndex = null;
    } else {
      this.rowDownloadDialogIndex = index;
    }
  }
  private async checkDeviceAndRedirect(): Promise<void> {
    this.isLoading = false;
    this.loadDropdownData();
  }
  closeRowDownloadDialog() {
    this.rowDownloadDialogIndex = null;
  }

  onApplicationIdClick(event: Event): void {

  }

  openDeleteModal(): void {
    this.showDeleteModal = true;
  }

  confirmDeleteWitnessRow() {
    if (this.isSupportingDelete && this.supportingDocDeleteIndex !== null) {
      const fileItem = this.filteredsupportingWitnessesData && this.filteredsupportingWitnessesData[this.supportingDocDeleteIndex];
      const url = fileItem.strFileHash;
      const contentType = fileItem.strDocumentType;
      this.httpService.deleteFile(url, contentType).subscribe({
        next: (response) => {
          this.handleSupportingWitnessDelete();
        },
        error: (error) => {
          console.error('Error deleting file:', error);
        }
      });

    }
    if (this.witnessDeleteIndex !== null && this.filteredwitnessesData[this.witnessDeleteIndex]) {
      this.handleWitnessDelete();
    }
    this.resetDeleteState();
  }

  private handleSupportingWitnessDelete() {
    const deletedFile = this.filteredsupportingWitnessesData[this.supportingDocDeleteIndex!];
    this.filteredsupportingWitnessesData.splice(this.supportingDocDeleteIndex!, 1);
    this.filteredsupportingWitnessesData = [...this.filteredsupportingWitnessesData];
    if (this.uploadedFiles.length === 1 && this.uploadedFiles[0]?.file === deletedFile?.file) {
      this.uploadedFiles = [];
    }
    this.supportingWitnessesDataGrid = DataGridVO.create({
      customHeaders: [...this.supportingWitnessesHeaders],
      visibleColumns: { ...this.visibleSupportingColumns },
      data: this.filteredsupportingWitnessesData,
      _changeKey: Date.now() + Math.random()
    });
    this.alertService.success(this.toastMessage['T0042']);
    if (this.cdr && typeof this.cdr.detectChanges === 'function') {
      this.cdr.detectChanges();
    }
    this.isSupportingDelete = false;
    this.supportingDocDeleteIndex = null;
    this.showDeleteModal = false;
  }

  private handleWitnessDelete() {
    this.filteredwitnessesData.splice(this.witnessDeleteIndex!, 1);
    this.filteredwitnessesData = [...this.filteredwitnessesData];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: [...this.witnessesHeaders],
      visibleColumns: { ...this.visibleColumns },
      data: this.filteredwitnessesData,
      _changeKey: Date.now() + Math.random()
    });
    if (this.employeeGrid && this.employeeGrid.applicationData) {
      this.employeeGrid.applicationData = [];
    }
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: [...this.witnessesHeaders],
      visibleColumns: { ...this.visibleColumns },
      data: this.filteredwitnessesData.length ? this.filteredwitnessesData : [],
      _changeKey: Date.now() + Math.random()
    });
    if (this.filteredwitnessesData.length === 0 && this.employeeGrid && this.employeeGrid.applicationData) {
      this.employeeGrid.applicationData = [];
    }
    if (this.employeeGrid && this.employeeGrid.dataGrid && this.employeeGrid.dataGrid.instance) {
      this.employeeGrid.dataGrid.instance.refresh();
    }
    this.alertService.success(this.toastMessage['T0040']);
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
    this.witnessDeleteIndex = null;
  }

  private resetDeleteState() {
    this.isSupportingDelete = false;
    this.supportingDocDeleteIndex = null;
    this.showDeleteModal = false;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.witnessDeleteIndex = null;
    this.selectedApplicationId = null;
  }

  deleteWitnessRow(index: number) {
    this.witnessDeleteIndex = index;
    this.showDeleteModal = true;
  }

  continueDraft() {
    if (this.draftApplication) {
      this.onApplicationIdClick(this.draftApplication);
    }
    this.showDraftModal = false;
    this.draftApplication = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    let clickedInside = false;
    const searchContainers = this.elRef.nativeElement.querySelectorAll('.search-container');
    searchContainers.forEach((container: HTMLElement) => {
      if (container.contains(event.target as Node)) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      for (const key of Object.keys(this.searchStates)) {
        if (this.searchStates[key]) {
          this.searchStates[key] = false;
        }
      }
    }
  }

  openShowSubmittedModal(): void {
    const options: NgbModalOptions = {
      backdrop: "static",
      centered: true,
      size: "md"
    };

    this.customModal = this.modalService.open(ModalComponent, options);

    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.ok, code: 'N', btnOutline: false }
      ],
      heading: modalHeading.applicationAlreadySubmitted,
      modalContent: modalContent.applicationAlreadySubmitted,
      hasTemplate: true,
      scrollable: true
    };

    this.customModal.componentInstance.modalConfig = modalConfig;
  }

  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000); // 4 seconds
  }

  openEditModal(mailType) {
    let dialogRef: MatDialogRef<any>;
    if (mailType === 'primaryEmail') {
      dialogRef = this.dialog.open(UpdateEmailComponent, {
        width: '400px',
        data: { emailType: 'primaryEmail', currentEmail: this.complaintForm.get('complainantEmail')?.value ? this.complaintForm.get('complainantEmail')?.value : '', titleStr: 'Update Complainant Email Address' },
        panelClass: 'custom-modalbox'
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result.response === 'success') {
        this.toastTitle = '';
        this.toastMessageText = 'Contact Information Updated.';
        this.toastType = 'success';
        this.showToast = true;
        this.complaintForm.get('complainantEmail')?.setValue(result.newEmail);
        this.setShortToastTimer();
        this.saveText = 'Update';

        if (result.type === 'primaryEmail') {
        }

        else if (result.type === 'phoneNumber') {

        }
        this.cdr.detectChanges(); // Ensure view updates
      } else {
      }
    });
  }

  checkPhone() {
    let cleanedPhoneNumber = this.complaintForm.get('phoneNumber')?.value.replace(/\D/g, '');
    let request = {
      phone: cleanedPhoneNumber
    };
    if (this.complaintForm.get('phoneNumber')?.value !== '') {
      this.registrationService.checkPhone(request).subscribe({
        next: response => {
          if (response.data.exists === true) {
            // this.closeConfirmModal();
            window.scrollTo(0, 0);
            this.phoneError = true;
            this.phoneExists = true;
            setTimeout(() => {
              this.phoneError = false;
            }, 5000);
          } else {
            this.phoneError = false;
            this.phoneExists = false;
          }
        }
      });
    }
  }

  formatPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.complaintForm.get('complainantPhoneNumber')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.complaintForm.get('complainantPhoneNumber')?.setValue(formatted, { emitEvent: false });
  }
  formatWitnessPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.witnessesForm.get('witnessesPhone')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.witnessesForm.get('witnessesPhone')?.setValue(formatted, { emitEvent: false });
  }
  formatEditWitnessPhoneNumber(event: any) {
    const inputEl = event.target;
    let value = inputEl.value;   
    const inputType = event.inputType; 
    // "deleteContentBackward", "insertText", etc.
    const isDeleting = inputType && inputType.includes('delete');
    //Allow deletion of +1 fully
    if (isDeleting) {
      this.editWitnessesForm.get('witnessesPhone')?.setValue(value, { emitEvent: false });
      return;
    }
    if (!value.startsWith('+1') && value !== '+') {
      value = '+1 ' + value.replace(/^\+/, '');
    }
    const formatted = this.formatPhoneNumberValue(value);
    inputEl.value = formatted;
    this.editWitnessesForm.get('witnessesPhone')?.setValue(formatted, { emitEvent: false });
  }

  cityStateRequiredIfZipValid(form: FormGroup) {
    const zip = form.get('complainantZip')?.value || '';
    const city = form.get('complainantCity')?.value || '';
    const state = form.get('complainantState')?.value || '';
    const zipPattern = /^\d{5}$|^\d{5}-\d{4}$/;

    // If zip is valid but city or state is missing, return error
    if (zipPattern.test(zip) && (!city || !state)) {
      return { cityStateMissing: true };
    }
    return null;
  }

  zipCodeFormat(event: any, controlName: string) {
    let value = event.target.value.replace(/[^0-9]/g, '');
    let formatted = value;
    let error: string | null = null;
    if (value.length > 9) value = value.substring(0, 9);
    if (value.length === 5) {
      formatted = value;
    } else if (value.length === 9) {
      formatted = value.substring(0, 5) + '-' + value.substring(5);
    } else if (value !== "") {
      error = 'M0023';
    }
    if (controlName === 'complainantZip') {
      this.complaintForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.complaintForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.complaintForm.get(controlName)?.setErrors(null);
      }
    } else if(controlName === 'witnessesZip') {
      this.witnessesForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.witnessesForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.witnessesForm.get(controlName)?.setErrors(null);
      }
    }
     else if(controlName === 'witnesseZip') {
      this.editWitnessesForm.get(controlName)?.setValue(formatted, { emitEvent: false });
      if (error) {
        this.editWitnessesForm.get(controlName)?.setErrors({ [error]: true });
      } else {
        this.editWitnessesForm.get(controlName)?.setErrors(null);
      }
    }

  }

  formatWitnessZipCode(event: any) {
    // Allow alphabets, numbers, spaces, and hyphens, max 10 chars
    let value = event.target.value.replace(/[^A-Za-z0-9\s-]/g, '');
    if (value.length > 10) value = value.substring(0, 10);
    this.witnessesForm.get('witnessesZip')?.setValue(value, { emitEvent: false });
    // Let validators handle errors
  }

  getWitnessRowIndex(row: any): number {
    return this.filteredwitnessesData.findIndex(r =>
      r.strWitnessName === row.strWitnessName &&
      r.strWitnessEmailAddress === row.strWitnessEmailAddress &&
      r.strWitnessPhoneNumber === row.strWitnessPhoneNumber
    );
  }
 
  
  onComplaintEditorInteraction(event:Event): void {
    const control = this.complaintForm.get('complaintTextData');
    try {
      console.log('onComplaintEditorInteraction called');
    } catch { }
    if (control && !control.touched) {
      control.markAsTouched();
    }
    const value = control?.value;
    const MAX_CHARS = 4000;
    if(value?.length >= MAX_CHARS){
      const truncated = value.slice(0, MAX_CHARS);

      // Update the form control (keeps things consistent)
      // NOTE: This replaces content with plain text (formatting lost).
      this.complaintForm.get('complaintTextData')?.setValue(truncated, { emitEvent: false });

    }
  }

  get formTouched(): boolean {
    return this.witnessesForm.dirty || Object.values(this.witnessesForm.controls).some(ctrl => ctrl.dirty);
  }
  get formTouchedd(): boolean {
    return this.editWitnessesForm.dirty || Object.values(this.editWitnessesForm.controls).some(ctrl => ctrl.dirty);
  }
  get formControls() {
    return this.complaintForm.controls;
  }

  showUploadModal(content: any) {
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.autoSelectSingleCategory();

    this.modalService.open(content, { size: 'lg', centered: true });
    this.authServices.clearFormAttachments();
  }

  private autoSelectSingleCategory(): void {
    if (this.categories && this.categories.length === 1) {
      this.uploadData.category = this.categories[0].key;
      this.onCategoryChange();
    }
  }

  onCategoryChange() {
    this.uploadData.docType = '';
    this.docTypeError = '';
    if (this.uploadData.category) {
    }

    this.cdr.detectChanges();
  }

  deleteSupportingDocumentRow(index: number) {
    if (typeof index === 'object' && index !== null) {
      const row: any = index;
      if (row) {
        const foundIndex = (this.filteredsupportingWitnessesData as any[]).findIndex((r: any) => r.file === row.file && r.strFileName === row.strFileName);
        this.supportingDocDeleteIndex = foundIndex !== -1 ? foundIndex : null;
      } else {
        this.supportingDocDeleteIndex = null;
      }
    } else {
      this.supportingDocDeleteIndex = index;
    }
    this.isSupportingDelete = true;
    this.showDeleteModal = true;
  }

  downloadSupportingDocument(row: any) {
    const url = row.strFileHash;
    const contentType = row.strDocumentType;
    if (url) {
      this.httpService.getDownload(url, contentType).subscribe({
        next: (blob: Blob) => {
          const downloadLink = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          downloadLink.href = objectUrl;
          downloadLink.download = row.strFileName || 'downloaded_file';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(objectUrl);
        }
      });
    } else {
      this.alertService.error('No file URL available for download.');
    }
  }
  closeUploadPopup() {
    this.uploadError = null;
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }
    this.authServices.clearFormAttachments();
    this.modalService.dismissAll();
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.filteredDocumentTypes = [];
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
  }

  updatewitness() {
    if (this.editWitnessIndex === undefined || this.editWitnessIndex < 0) return;
    const updated = this.editWitnessesForm.getRawValue();
    const updatedWitness = {
      strWitnessName: updated.witnesseName,
      strWitnessEmailAddress: updated.witnessesEmail,
      strWitnessPhoneNumber: updated.witnessesPhone,
      strStreetAddress: updated.witnessesAddress,
      strCity: updated.witnessesCity,
      strState: typeof updated.witnessesState === 'string' ? updated.witnessesState : '',
      strZip: updated.witnesseZip,
      strWitnessTextData: updated.witnessesTextData
    };
    this.filteredwitnessesData[this.editWitnessIndex] = { ...this.filteredwitnessesData[this.editWitnessIndex], ...updatedWitness };
    this.filteredwitnessesData = [...this.filteredwitnessesData];
    this.witnessesDataGridConfig = DataGridVO.create({
      customHeaders: this.witnessesHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredwitnessesData
    });
    this.alertService.success(this.toastMessage['T0020']);
    if (this.cd && typeof this.cd.detectChanges === 'function') {
      this.cd.detectChanges();
    }
    this.closeModal();
  }

  validateWitnessEmail() {
    const emailControl = this.witnessesForm.get('witnessesEmail');
    const emailValue = emailControl?.value;
    if (!emailValue) {
      emailControl?.setErrors(null);
      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,10}$/;
    if (!emailPattern.test(emailValue)) {
      emailControl?.setErrors({ 'M0015': true });
    } else {
      emailControl?.setErrors(null);
    }
  }

  validateWitnessPhone() {
    const phoneControl = this.witnessesForm.get('witnessesPhone');
    const phoneValue = phoneControl?.value;
    if (!phoneValue) {
      phoneControl?.setErrors(null);
      return;
    }
    const phonePattern = /^(\\+1[ ]?)?\\(\\d{3}\\)[ ]?\\d{3}[ ]\\d{4}$/;
    if (!phonePattern.test(phoneValue)) {
      phoneControl?.setErrors({ 'M0022': true });
    } else {
      phoneControl?.setErrors(null);
    }
  }

  validateWitnessStreet() {
    const streetControl = this.witnessesForm.get('witnessesAddress');
    const streetValue = streetControl?.value;
    if (!streetValue) {
      streetControl?.setErrors(null);
      return;
    }
    const streetPattern = /^[A-Za-z0-9][A-Za-z0-9\s.,\-'/#]*$/;
    const errors: any = {};
    if (!streetPattern.test(streetValue)) {
      errors['M0052'] = true;
    }
    if (streetValue.length < 3) {
      errors['minlength'] = true;
    }
    if (streetValue.length > 60) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      streetControl?.setErrors(errors);
    } else {
      streetControl?.setErrors(null);
    }
  }
  onFileRejected(event: any) {
    if (event && event.type === 'size') {
      this.uploadError = this.errorMessage['M0128'];;
    } else if (event && event.type === 'type') {
      this.uploadError = this.errorMessage['M0129'];
    } else {
      this.uploadError = 'File upload error. Please select a valid file.';
    }
  }
  validateWitnessCity() {
    const cityControl = this.witnessesForm.get('witnessesCity');
    const cityValue = cityControl?.value;
    if (!cityValue) {
      cityControl?.setErrors(null);
      return;
    }
    const cityPattern = /^[A-Za-z\s'-]{2,60}$/;
    const errors: any = {};
    if (!cityPattern.test(cityValue)) {
      errors['pattern'] = true;
    }
    if (cityValue.length < 2) {
      errors['minlength'] = true;
    }
    if (cityValue.length > 60) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      cityControl?.setErrors(errors);
    } else {
      cityControl?.setErrors(null);
    }
  }

  validateWitnessZip() {
    const zipControl = this.witnessesForm.get('witnessesZip');
    const zipValue = zipControl?.value;
    if (!zipValue) {
      zipControl?.setErrors(null);
      return;
    }
    // Only allow numbers, spaces, and hyphens, length 3-10
    const zipPattern = /^[A-Za-z0-9\s-]{3,10}$/;
    const errors: any = {};
    if (!zipPattern.test(zipValue)) {
      errors['pattern'] = true;
      errors['M0023'] = true;
    }
    if (zipValue.length < 3) {
      errors['minlength'] = true;
    }
    if (zipValue.length > 10) {
      errors['maxlength'] = true;
    }
    if (Object.keys(errors).length > 0) {
      zipControl?.setErrors(errors);
    } else {
      zipControl?.setErrors(null);
    }
  }

  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  onComplainantFirstNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    this.complaintForm.get('complainantFirstName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }
  onComplainantLastNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    this.complaintForm.get('complainantLastName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }

  educatorsFirstName(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.complaintForm.get('educatorsFirstName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }

  witnessesName(event: any, formType: 'main' | 'modal' = 'main') {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    if (formType === 'main') {
      this.witnessesForm.get('witnessesName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
    } else {
      this.editWitnessesForm.get('witnesseName')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
    }
  }

  normalizeSpaces(value: string) {
    value = value.replace(/\s+/g, ' ');
    return value;
  }

  checkForTrailingSpace(event: any, controlName: string) {
    let value = event.target.value;
    this.complaintForm.get(controlName)?.setValue(value.trimEnd(), { emitEvent: false });
  }

  checkForSpecialCharAtEnd(controlName: string) {
    const fieldsToCheck = ['com'];
    if (!fieldsToCheck.includes(controlName)) return;

    const value = this.complaintForm.get(controlName)?.value;
    if (!value) return;

    let specialCharsPattern;
    if (controlName === 'complainantStreetAddress') {
      specialCharsPattern = /[.,\-'#\/]$/;
    } else {
      specialCharsPattern = /[.,\-&'()\/]$/;
    }

    // Check if the field ends with a special character
    const endsWithSpecialChar = specialCharsPattern.test(value);

    if (endsWithSpecialChar) {
      this.complaintForm.get(controlName)?.setErrors({
        ...this.complaintForm.get(controlName)?.errors,
        specialCharAtEnd: true
      });
    } else {
      // Remove the special character error if it exists
      const errors = this.complaintForm.get(controlName)?.errors;
      if (errors && errors['specialCharAtEnd']) {
        delete errors['specialCharAtEnd'];
        if (Object.keys(errors).length === 0) {
          this.complaintForm.get(controlName)?.setErrors(null);
        } else {
          this.complaintForm.get(controlName)?.setErrors(errors);
        }
      }
    }
  }

  // Clean up fields when user leaves them (blur event)
  onFieldBlur(event: any, controlName: string) {
    let value = event.target.value;
    value = value.trim();
    this.complaintForm.get(controlName)?.setValue(value, { emitEvent: false });

    // Check for special characters at the end of field
    this.checkForSpecialCharAtEnd(controlName);
  }

  preventBackToBackChars(value: string): string {
    value = value.replace(/^\s+/, '');
    value = value.replace(/\s{2,}/g, ' ');
    value = value.replace(/[.]{2,}/g, '.');
    value = value.replace(/[,]{2,}/g, ',');
    value = value.replace(/[-]{2,}/g, '-');
    value = value.replace(/[&]{2,}/g, '&');
    value = value.replace(/[']{2,}/g, "'");
    value = value.replace(/[\(]{2,}/g, '(');
    value = value.replace(/[\)]{2,}/g, ')');
    value = value.replace(/[\/]{2,}/g, '/');
    value = value.replace(/[#]{2,}/g, '#');
    value = value.replace(/([.,\-&'()\/#])\1+/g, '$1');
    while (/[.,\-&'()\/#][.,\-&'()\/#]/.test(value)) {
      value = value.replace(/([.,\-&'()\/#])([.,\-&'()\/#])/, '$1');
    }

    return value;
  }

  private formatPhoneNumberValue(input: string): string {
    if (!input) return '';
    input = input.replace(/[a-zA-Z]/g, '');
    // If starts with '+1', enforce '+1 (XXX) XXX XXXX' format
    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        input = '+1 ' + input.slice(2);
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      // Strip repeated country code: e.g. user pasted 18XXXXXXXXX after field already had "+1 "
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
    }
    // If starts with '(', enforce '(XXX) XXX XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // If only digits, format as '(XXX) XXX XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes
    if (input === '+' || input === '+1' || input === '+1 ') {
      return input;
    }
    // For any other input, clear the field
    return '';
  }

  onStreetAddressInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z0-9\s\.\,\-\'\#\/]/g, '');
    value = value.substring(0, 60);
    value = this.preventBackToBackChars(value);
    this.complaintForm.get('complainantStreetAddress')?.setValue(value, { emitEvent: false });
    this.checkForSpecialCharAtEnd('complainantStreetAddress');
  }
  handleFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.oneFileIsRequired = true;
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      return;
    }
    const file = input.files[0];
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'video/mp4',
      'audio/mpeg'
    ];
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.uploadError = this.errorMessage['M0128'];
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      this.uploadError = this.errorMessage['M0129'];
      this.uploadData.file = null;
      this.uploadData.type = '';
      this.uploadData.fileName = '';
      // Clear the file input so user must reselect
      if (this.fileInputRef && this.fileInputRef.nativeElement) {
        this.fileInputRef.nativeElement.value = '';
      }
      return;
    }
    this.uploadData.file = file;
    this.uploadData.type = this.uploadData.type || file.type;
    this.uploadData.fileName = file.name;
    this.oneFileIsRequired = false;
    this.uploadError = null;
    this.saveEnable = false;
  }


  onSave(): void {
    this.loaderService.show();
    let data = {
      fileName: `${this.uploadData.fileName}`,
      contentType: this.uploadData.type || ''
    };
    this.complaintFormService.getUploadKey(data).subscribe((res: any) => {
      this.saveEnable = true;
      const url = res.data;
      const uploadDetails = this.uploadData.file;
      const type = this.uploadData.type;
      const fileURL = res.data;
      this.httpService.putUpload(url, uploadDetails, type).subscribe(() => {
        this.alertService.success(this.toastMessage['T0041']);
        this.uploadedFiles = [{
          strFileName: this.uploadData.file.name,
          strFileHash: fileURL,
          strDocumentType: this.uploadData.type,
          strStatus: 'Uploaded',
          strCdDocumentCategory: this.uploadData.category,
          dtDateUploaded: new Date(),
        }
        ];
        this.filteredsupportingWitnessesData = [
          ...this.filteredsupportingWitnessesData,
          ...this.uploadedFiles
        ];
        this.supportingWitnessesDataGrid = DataGridVO.create({
          customHeaders: this.supportingWitnessesHeaders,
          visibleColumns: this.visibleSupportingColumns,
          data: this.filteredsupportingWitnessesData
        });
        this.closeUploadPopup();
        this.loaderService.hide();
      });
    });
  }
  clearState(element?: HTMLSelectElement, complaintForm?: boolean, editWitnessModal?: boolean) {
    if (complaintForm === true) {
      this.complaintForm.get('complainantState')?.setValue(null);
    } else if (editWitnessModal === true) {
      const ctrl = this.editWitnessesForm.get('witnessesState');
      ctrl?.setValue(null);
      ctrl?.markAsDirty();
      ctrl?.markAsTouched();
      this.editWitnessesForm.markAsDirty();
      this.editWitnessesForm.markAsTouched();
      setTimeout(() => {
        this.editWitnessesForm.updateValueAndValidity();
      }, 0);
    } else {
      this.witnessesForm.get('witnessesState')?.setValue(null);
    }
    if (element) {
      // focus the select after clearing so keyboard users can continue
      try {
        element.focus();
      } catch (e) {
        // ignore focus errors
      }
    }
  }
  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
    this.dtEffEndDateDestroy$.next();
    this.dtEffEndDateDestroy$.complete();
  }
}
